// extracted by mini-css-extract-plugin
export default {"shortcuts":"emp_src-components-common-DatePicker-styles-Shortcuts__shortcuts--ua8b_"};